module.exports = new __parcel__URL__("eurobricks.39d2984d.webp").toString();